export class Contratacion {
    ncontratacionId: number;
    ccontratacionNroruc: string;
    ccontratacionDscobjeto: string;
    ccontratacionDscobjcont: string;
    ccontratacionDsctipselecc: string;
    ncontratacionIdtiposelecc: number =  null;
    ccontratacionCodanho: string = null;
    ccontratacionNroselecc: string;
    ccontratacionCodsnip: string;
    ccontratacionDscmodaselecc: string;
    ncontratacionIdmodaselecc: number = null;
    ccontratacionDscindicconv: string;
    ccontratacionDsctipcompra: string;
    ncontratacionIdtipcompra: number = null;
    ccontratacionCdepent: string;
    ccontratacionCprovent: string;
    ccontratacionCdistent: string;
    ccontratacionCodent: string;
    ccontratacionDscnomenclatura: string;
    ccontratacionDscnormativa: string;
    ccontratacionDscversseace: string;
    ccontratacionDscwebent: string;
    ccontratacionDscdirlegent: string;
    ccontratacionDsctelefent: string;
    ncontratacionImpmonto: number;
    strNcontratacionImpmonto: string;
    dcontratacionFchpublic: Date;
    strDcontratacionFchpublic: string;
    ncontratacionImpvalorest: number;
    strNcontratacionImpvalorest: string;
    ccontratacionDscmoneda: string;
    ncontratacionIdmoneda: number = null;
}
